var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{staticClass:"material-check",style:(_vm.customStyle)},_vm._l((_vm.list),function(item,index){return _c('div',{key:item.id,staticClass:"item",class:{'active': _vm.activeIndex == index},on:{"click":function($event){return _vm.handleClick(index, item)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }